import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import ArticlesPage from "../pages/articles/page";
import ArticleDetail from "../pages/article/page";
import CategoryPage from "../pages/category/page";
import FaqPage from "../pages/faq/page";
import AboutPage from "../pages/about/page";
import ContactPage from "../pages/contact/page";
import PageLayout from "../components/feature/PageLayout";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    element: <PageLayout />,
    children: [
      { path: "/articles", element: <ArticlesPage /> },
      { path: "/article/:slug", element: <ArticleDetail /> },
      { path: "/category/:slug", element: <CategoryPage /> },
      { path: "/faq", element: <FaqPage /> },
      { path: "/about", element: <AboutPage /> },
      { path: "/contact", element: <ContactPage /> },
    ],
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;